import { Pipe, PipeTransform } from '@angular/core';
import { List, ListIterateeCustom, some } from 'lodash';

@Pipe({
  name: 'some',
  standalone: true,
})
export class SomePipe implements PipeTransform {
  public transform(
    array: List<unknown> | null | undefined,
    predicate?: ListIterateeCustom<unknown, boolean> | undefined
  ): boolean {
    return some(array, predicate);
  }
}
